import { ModBox, SpacerNew } from '@jfs/ui-new'
import { FinancialServices } from './FinancialServices'

export const RenderCategory = ({ categoryList }: any) => {
  let list: any = []
  if (categoryList?.length) {
    list = categoryList.map((category) => {
      return (
        <ModBox show={categoryList?.categoryList?.length}>
          <SpacerNew size={8} direction="vertical" />
          <FinancialServices data={category?.categoryList} title={category?.categoryType} />
        </ModBox>
      )
    })
  }
  return list
}
